<script>
export default {
    name: "PatientReportsHome",
}
</script>
<template>
  <tail-base-layout>
      <template v-slot:content>
        <div class="flex flex-wrap">
                <div class="w-full text-center bg-blue-500 p-1 rounded-md mx-2">
                    <h5 class="text-white font-bold text-base">Patient Reports</h5>
                </div>
                <div class="w-full md:w-1/3 xl:w-1/4 p-3"  v-if="$root.checkAuth(`reports.patients.all-patients.index`)">
                    <!--Metric Card-->
                    <div class="bg-green-100 border-b-4 border-green-600 rounded-lg shadow-lg p-1">
                        <router-link :to="{ name: `reports.patients.all-patients.index` }">
                            <div class="flex flex-row items-center">
                                <div class="flex-shrink pr-2">
                                    <div class="rounded-full p-3 bg-green-600"><i class="fas fa-users fa-2x fa-inverse"></i></div>
                                </div>
                                <div class="flex-1 text-right md:text-center">
                                    <h5 class="font-bold uppercase text-gray-600">All Patient Reports</h5>
                                </div>
                            </div>
                        </router-link>
                    </div>
                    <!--/Metric Card-->
                </div>
                <div class="w-full md:w-1/2 xl:w-1/4 p-3"  v-if="$root.checkAuth(`reports.patients.registration-report.index`)">
                    <!--Metric Card-->
                    <div class="bg-orange-100 border-b-4 border-orange-500 rounded-lg shadow-lg p-1">
                        <router-link :to="{ name: `reports.patients.registration-report.index` }">
                            <div class="flex flex-row items-center">
                                <div class="flex-shrink pr-4">
                                    <div class="rounded-full p-3 bg-orange-600"><i class="fas fa-user-plus fa-2x fa-inverse"></i></div>
                                </div>
                                <div class="flex-1 text-right md:text-center">
                                    <h5 class="font-bold uppercase text-gray-600">Registration Report</h5>
                                </div>
                            </div>
                        </router-link>
                    </div>
                    <!--/Metric Card-->
                </div>
                <div class="w-full md:w-1/2 xl:w-1/4 p-3" v-if="$root.checkAuth(`reports.patients.visits-report.index`)">
                    <div class="bg-yellow-100 border-b-4 border-yellow-600 rounded-lg shadow-lg p-1">
                        <router-link :to="{ name: `reports.patients.visits-report.index` }">
                            <div class="flex flex-row items-center">
                                <div class="flex-shrink pr-4">
                                    <div class="rounded-full p-3 bg-yellow-600"><i class="fas fa-edit fa-2x fa-inverse"></i></div>
                                </div>
                                <div class="flex-1 text-right md:text-center">
                                    <h5 class="font-bold uppercase text-gray-600">Visit Report</h5>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>
                 <div class="w-full md:w-1/2 xl:w-1/4 p-3" v-if="$root.checkAuth(`reports.patients.nhif-visits-report.index`)">
                    <div class="bg-blue-100 border-b-4 border-blue-500 rounded-lg shadow-lg p-1">
                        <router-link :to="{ name: `reports.patients.nhif-visits-report.index` }">
                            <div class="flex flex-row items-center">
                                <div class="flex-shrink pr-4">
                                    <div class="rounded-full p-3 bg-blue-600"><i class="fas fa-server fa-2x fa-inverse"></i></div>
                                </div>
                                <div class="flex-1 text-right md:text-center">
                                    <h5 class="font-bold uppercase text-gray-600">NHIF Visit Report</h5>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>
                 <div class="w-full md:w-1/2 xl:w-1/4 p-3" v-if="$root.checkAuth(`reports.patients.documents-report.index`)">
                    <div class="bg-indigo-100 border-b-4 border-indigo-500 rounded-lg shadow-lg p-1">
                        <router-link :to="{ name: `reports.patients.documents-report.index` }">
                            <div class="flex flex-row items-center">
                                <div class="flex-shrink pr-4">
                                    <div class="rounded-full p-3 bg-indigo-600 text-white"><i class="fas fa-folder fa-2x fa-inverse"></i></div>
                                </div>
                                <div class="flex-1 text-right md:text-center">
                                    <h5 class="font-bold uppercase text-gray-600">Document Report</h5>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>
                 <div class="w-full md:w-1/2 xl:w-1/4 p-3" v-if="$root.checkAuth(`reports.patients.admission-report.index`)">
                    <div class="bg-red-100 border-b-4 border-red-500 rounded-lg shadow-lg p-1">
                        <router-link :to="{ name: `reports.patients.admission-report.index` }">
                            <div class="flex flex-row items-center">
                                <div class="flex-shrink pr-4">
                                    <div class="rounded-full p-3 bg-gray-600"><i class="fas fa-file fa-2x fa-inverse"></i></div>
                                </div>
                                <div class="flex-1 text-right md:text-center">
                                    <h5 class="font-bold uppercase text-gray-600">Admission Report</h5>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>
                <div class="w-full md:w-1/2 xl:w-1/4 p-3" v-if="$root.checkAuth('reports.patients.patient-admission-report.index')">
                    <div class="bg-red-100 border-b-4 border-red-500 rounded-lg shadow-lg p-1">
                        <router-link :to="{ name: `reports.patients.patient-admission-report.index` }">
                            <div class="flex flex-row items-center">
                                <div class="flex-shrink pr-4">
                                    <div class="rounded-full p-3 bg-gray-600"><i class="fas fa-file fa-2x fa-inverse"></i></div>
                                </div>
                                <div class="flex-1 text-right md:text-center">
                                    <h5 class="font-bold uppercase text-gray-600">Patients Admission Report</h5>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>
                 <div class="w-full md:w-1/2 xl:w-1/4 p-3" v-if="$root.checkAuth(`reports.patients.current-inpatients-report.index`)">
                    <div class="bg-indigo-200 border-b-4 border-indigo-500 rounded-lg shadow-lg p-1">
                        <router-link :to="{ name: `reports.patients.current-inpatients-report.index` }">
                            <div class="flex flex-row items-center">
                                <div class="flex-shrink pr-4">
                                    <div class="rounded-full p-3 bg-blue-800"><i class="fas fa-procedures fa-2x fa-inverse"></i></div>
                                </div>
                                <div class="flex-1 text-right md:text-center">
                                    <h5 class="font-bold uppercase text-gray-600">Current Inpatients Report</h5>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>
                 <div class="w-full md:w-1/2 xl:w-1/4 p-3" v-if="$root.checkAuth(`reports.patients.gate-pass-report.index`)">
                    <div class="bg-yellow-200 border-b-4 border-yellow-500 rounded-lg shadow-lg p-1">
                        <router-link :to="{ name: `reports.patients.gate-pass-report.index` }">
                            <div class="flex flex-row items-center">
                                <div class="flex-shrink pr-4">
                                    <div class="rounded-full p-3 bg-orange-800"><i class="fas fa-key fa-2x fa-inverse"></i></div>
                                </div>
                                <div class="flex-1 text-right md:text-center">
                                    <h5 class="font-bold uppercase text-gray-600">Gate pass Report</h5>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>
                 <div class="w-full md:w-1/2 xl:w-1/4 p-3" v-if="$root.checkAuth(`reports.patients.discharge-report.index`)">
                    <div class="bg-green-200 border-b-4 border-green-500 rounded-lg shadow-lg p-1">
                        <router-link :to="{ name: `reports.patients.discharge-report.index` }">
                            <div class="flex flex-row items-center">
                                <div class="flex-shrink pr-4">
                                    <div class="rounded-full p-3 bg-blue-600"><i class="fas fa-redo fa-2x fa-inverse"></i></div>
                                </div>
                                <div class="flex-1 text-right md:text-center">
                                    <h5 class="font-bold uppercase text-gray-600">Discharge Report</h5>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>
                 <div class="w-full md:w-1/2 xl:w-1/4 p-3" v-if="$root.checkAuth(`reports.patients.op-diagnosis-report.index`)">
                    <div class="bg-purple-200 border-b-4 border-purple-500 rounded-lg shadow-lg p-1">
                        <router-link :to="{ name: `reports.patients.op-diagnosis-report.index` }">
                            <div class="flex flex-row items-center">
                                <div class="flex-shrink pr-4">
                                    <div class="rounded-full p-3 bg-purple-800"><i class="fas fa-file-medical-alt fa-2x fa-inverse"></i></div>
                                </div>
                                <div class="flex-1 text-right md:text-center">
                                    <h5 class="font-bold uppercase text-gray-600">Outpatient Diagnosis Report</h5>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>
                 <div class="w-full md:w-1/2 xl:w-1/4 p-3" v-if="$root.checkAuth(`reports.patients.ip-diagnosis-report.index`)">
                    <div class="bg-red-200 border-b-4 border-red-500 rounded-lg shadow-lg p-1">
                        <router-link :to="{ name: `reports.patients.ip-diagnosis-report.index` }">
                            <div class="flex flex-row items-center">
                                <div class="flex-shrink pr-4">
                                    <div class="rounded-full p-3 bg-red-800"><i class="fas fa-stethoscope fa-2x fa-inverse"></i></div>
                                </div>
                                <div class="flex-1 text-right md:text-center">
                                    <h5 class="font-bold uppercase text-gray-600">InPatients Diagnosis Report</h5>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>
                <div class="w-full md:w-1/2 xl:w-1/4 p-3" 
                    v-if="$root.checkAuth('appointments.index')">
                    <!--Metric Card-->
                    <div class="bg-blue-400 border-b-4 border-blue-700 rounded-lg shadow-lg p-1">
                        <router-link :to="{ name: `appointments.index`}">
                            <div class="flex flex-row items-center">
                                <div class="flex-shrink pr-4">
                                    <div class="rounded-full p-5 bg-blue-600"><i class="fas fa-tasks fa-2x fa-inverse"></i></div>
                                </div>
                                <div class="flex-1 text-right md:text-center">
                                    <h5 class="font-bold uppercase text-gray-600">Appointments</h5>
                                </div>
                            </div>
                        </router-link>
                    </div>
                    <!--/Metric Card-->
                </div>
                <div class="w-full md:w-1/2 xl:w-1/4 p-3" 
                    v-if="$root.checkAuth('reports.patients.tb-screening-report.index')"
                    >
                    <!--Metric Card-->
                    <div class="bg-blue-400 border-b-4 border-yellow-700 rounded-lg shadow-lg p-1">
                        <router-link :to="{ name: `reports.patients.tb-screening-report.index`}">
                            <div class="flex flex-row items-center">
                                <div class="flex-shrink pr-4">
                                    <div class="rounded-full p-5 bg-yellow-600"><i class="fas fa-tasks fa-2x fa-inverse"></i></div>
                                </div>
                                <div class="flex-1 text-right md:text-center">
                                    <h5 class="font-bold uppercase text-gray-600">TB Screening Report</h5>
                                </div>
                            </div>
                        </router-link>
                    </div>
                    <!--/Metric Card-->
                </div>
                <div class="w-full md:w-1/2 xl:w-1/4 p-3" 
                    v-if="$root.checkAuth('reports.patients.progressnotes-report.index')"
                    >
                    <!--Metric Card-->
                    <div class="bg-red-100 border-b-4 border-red-600 rounded-lg shadow-lg p-1">
                        <router-link :to="{ name: `reports.patients.progressnoteslist.index`}">
                            <div class="flex flex-row items-center">
                                <div class="flex-shrink pr-4">
                                    <div class="rounded-full p-5 bg-indigo-600"><i class="fas fa-check-double fa-2x fa-inverse"></i></div>
                                </div>
                                <div class="flex-1 text-right md:text-center">
                                    <h5 class="font-bold uppercase text-gray-600">Progress Notes Report</h5>
                                </div>
                            </div>
                        </router-link>
                    </div>
                    <!--/Metric Card-->
                </div>
                 <div class="w-full md:w-1/2 xl:w-1/4 p-3" v-if="$root.checkAuth(`reports.patients.daily-report.index`)">
                    <div class="bg-yellow-100 border-b-4 border-yellow-600 rounded-lg shadow-lg p-1">
                        <router-link :to="{ name: `reports.patients.daily-report.index` }">
                            <div class="flex flex-row items-center">
                                <div class="flex-shrink pr-4">
                                    <div class="rounded-full p-3 bg-yellow-600"><i class="fas fa-edit fa-2x fa-inverse"></i></div>
                                </div>
                                <div class="flex-1 text-right md:text-center">
                                    <h5 class="font-bold uppercase text-gray-600">Daily Report</h5>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>
            </div>
      </template>
</tail-base-layout>
</template>